<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6">{{ new Date().getFullYear() }} © Asset Flow.</div>
        <div v-if="version" class="col-sm-6 text-right">Version {{version}}</div>
      </div>
    </div>
  </footer>
  <!-- end footer -->
</template>

<script>
export default {
  data() {
    return {
      version: window.afAppVersion || ''
    };
  }
};
</script>